import LiveKitVideoRoom from './LiveKitVideoRoom';

import TelemedicineContext from '../../../context/telemedicine';
import { takePreparedRoom } from '../../../utils/livekit-room';
import { createRoomOptions } from '../../../utils/room-options';
import { discardPreviewTracks } from '../../WaitingRoom/preview-tracks';

import { showErrorToast } from '@amigoapp/doca-react';
import { RoomContext, usePersistentUserChoices } from '@livekit/components-react';
import { Room, RoomEvent } from 'livekit-client';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LiveKitVideoRoomContainer = () => {
	const navigate = useNavigate();
	const { telemedicine } = useContext(TelemedicineContext);
	const { userChoices } = usePersistentUserChoices();

	const [room] = useState(() => takePreparedRoom() || new Room(createRoomOptions({
		videoDeviceId: userChoices.videoDeviceId,
		audioDeviceId: userChoices.audioDeviceId
	})));

	const goToFinished = useCallback(() => navigate('/telemedicine-finished'), [navigate]);

	const goToFinishedRef = useRef(goToFinished);

	goToFinishedRef.current = goToFinished;

	const { url, token } = telemedicine.livekit;

	useEffect(() => {
		let leaving = false;

		const handleDisconnected = () => {
			if (!leaving) {
				goToFinishedRef.current();
			}
		};

		room.on(RoomEvent.Disconnected, handleDisconnected);

		room.connect(url, token).catch(() => {
			if (!leaving) {
				showErrorToast('Não foi possível entrar na chamada.');
			}
		});

		return () => {
			leaving = true;

			room.off(RoomEvent.Disconnected, handleDisconnected);
			room.disconnect();

			discardPreviewTracks();
		};
	}, [room, url, token]);

	useEffect(() => {
		window.socket.on('telemedicine:room-closed', goToFinished);

		return () => {
			window.socket.off('telemedicine:room-closed', goToFinished);
		};
	}, [goToFinished]);

	return (
		<div className="lk-room-container">
			<RoomContext.Provider value={room}>
				<LiveKitVideoRoom />
			</RoomContext.Provider>
		</div>
	);
};

export default LiveKitVideoRoomContainer;
